"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This is the [React](https://reactjs.org/) component for Vanilla [Tabs](https://vanillaframework.io/docs/patterns/tabs).
Tabs organise and allow navigation between groups of content that are related and at the same level
of hierarchy.
 */
const Tabs = _ref => {
  let {
    className,
    links,
    listClassName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: (0, _classnames.default)("p-tabs", className)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)("p-tabs__list", listClassName)
  }, links.map((link, i) => {
    const {
      active,
      className,
      component,
      label,
      listItemClassName,
      ...rest
    } = link;
    const Component = component || "a";
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)("p-tabs__item", listItemClassName),
      key: i
    }, /*#__PURE__*/_react.default.createElement(Component, _extends({
      "aria-selected": active,
      className: (0, _classnames.default)("p-tabs__link", className),
      "data-testid": "tab-link-".concat(label)
    }, rest), label));
  })));
};
var _default = exports.default = Tabs;